// Dependencies
require("webstrap/scaffolding");

// JavaScript
// Import loader is important to expose jQuery
require("imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/transition.js");
require("imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/button.js");

// Styles
require("./buttons.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/buttons/index.js
 ** module id = 21
 ** module chunks = 0 1
 **/